interface Props {
    setShowNews: (boolean: boolean) => void,
}

const News = (props: Props) => {
    return (
        <section className='news-backdrop'>
            <article className="news">
                <button className='close-news' onClick={() => props.setShowNews(false)}>X</button>
                <h2>Glad sommar!</h2>
                {/* <h3>Höstterminen börjar 18/8</h3> */}
                <div>
                    <p>Fram till terminsstart gäller sommarschemat. Titta under "Schema" för att se tiderna.</p>
                    <p>Välkommen!</p>
                </div>
            </article>
        </section>
    );
};

export default News;